export class OfferState {
  public static readonly CODE_OFFEN = 'OFFEN';
  public static readonly CODE_TEILVERH = 'TEILVERH';
  public static readonly CODE_VERH = 'VERH';
  public static readonly CODE_ABGEL = 'ABGEL';
}
